import SharedStorageAgentInterface from "../SharedStorageAgentInterface.js"

class SharedStorageAgentSubscribeWrapperQiankun extends SharedStorageAgentInterface {
    constructor(storageAgent) {
        super();
        this.storageAgent = storageAgent;
        this.subscribed = {};
    }

    get = async (key = null) => {
        return this.storageAgent.get(key);
    }

    set = async (key, value) => {
        const wait = await this.storageAgent.set(key, value);
        this._onValueChange(key, value);
        return this;
    }

    reset = async (key=null) => {
        const wait = await this.storageAgent.reset(key);
        const value = await this.get(key);
        this._onValueChange(key, value);
        return this;
    }

    subscribe = async (key, onChange) => {
        // add the onChange callback to the list of callbacks for the key
        if (!this.subscribed[key]) {
            this.subscribed[key] = [];
        }        
        this.subscribed[key].push(onChange);

        // call onChange immediately after subscribing
        const curValue = await this.storageAgent.get(key);
        onChange(curValue);

        // return an unsubscribe func that removes the onChange callback
        const unsubscribe = () => {
            const index = this.subscribed[key].indexOf(onChange);
            if (index !== -1) {
                this.subscribed[key].splice(index, 1);
            }
        }
        return unsubscribe;
    }

    _onValueChange = (key, value) => {
        const subscribedList = this.subscribed[key];
        if (!subscribedList) return;
        // call each of the subscribed onChange functions for the changed key
        const parsedValue = this._extractFormattedValue(value);
        subscribedList.forEach(onChange => onChange(parsedValue));
        return this;
    }

    // check the agent set method for documentation
    _extractFormattedValue = (value) => {
        if (value?._set_by) {
            return value.value;
        }
        return value;
    }
}

export default SharedStorageAgentSubscribeWrapperQiankun;